import HttpRequest from './http_request'
import { getStoreBearer, getUser } from '@/utils/helper/localStorage'

class SellsukiProvider extends HttpRequest {
  constructor () {
    super(process.env.SELLSUKI_URL)
  }
  async fetchBranch () {
    this.setHeader({
      'Authorization': await getStoreBearer()
    })
    let userCashier = await this.getCashier()
    const { data: { results } } = await this.get('/pos/branch')
    const resultTranformed = this.transformResult(results)
    let result = []
    resultTranformed.map(async branch => {
      if (userCashier.branchID.findIndex(b => b === branch.id) !== -1) {
        await result.push(branch)
      }
    })
    return result
  }

  async getCashier () {
    this.setHeader({
      'Authorization': await getStoreBearer()
    })
    const { data: { results } } = await this.get('/pos/cashier')
    const result = this.mapUserCashier(results)
    return result
  }

  mapUserCashier (results) {
    const loginUser = getUser()
    const filteredCashier = results.find(user => user.id === loginUser.id)
    return {
      ...filteredCashier,
      branchID: filteredCashier.concat_cashier_branch_id ? filteredCashier.concat_cashier_branch_id.split(':;:') : [],
      branchName: filteredCashier.concat_cashier_branch_name ? filteredCashier.concat_cashier_branch_name.split(':;:') : []
    }
  }

  transformResult (results) {
    let data = []
    results.map(item => {
      data.push({
        ...item,
        posID: item.concat_pos_id ? item.concat_pos_id.split(':;:') : [],
        unitID: item.concat_unit_id ? item.concat_unit_id.split(':;:') : [],
        posWarehouse: item.concat_pos_warehouse ? item.concat_pos_warehouse.split(':;:') : [],
        posWarehouseDisplayName: item.concat_pos_warehouse_display_name ? item.concat_pos_warehouse_display_name.split(':;:') : []
      })
    })
    return data
  }
}

export default SellsukiProvider



// WEBPACK FOOTER //
// ./src/resources/sellsuki_provider.js